var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "company-apply-dialog",
          attrs: {
            title: _vm.title,
            visible: _vm.innerVisible,
            "close-on-click-modal": false,
            "append-to-body": "",
            "before-close": _vm.handleClose,
            width: "860px"
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("h1", [_vm._v(_vm._s(_vm.workflowTitle))]),
            _c(
              "table",
              {
                staticClass: "details-table",
                attrs: { cellpadding: "0", cellspacing: "0" }
              },
              [
                !_vm.isApply
                  ? _c("tr", [
                      _c("td", { staticClass: "header" }, [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_ApprovalSerialNumber"))
                        )
                      ]),
                      _c("td", { staticClass: "values" }, [
                        _vm._v(_vm._s(_vm.processInfo.documentProcessNo))
                      ]),
                      _c("td", { staticClass: "header" }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_StartDate")))
                      ]),
                      _c("td", { staticClass: "values" }, [
                        _vm._v(_vm._s(_vm.processInfo.createDate))
                      ])
                    ])
                  : _vm._e(),
                _c("tr", [
                  _c("td", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Applicant")))
                  ]),
                  _c("td", { staticClass: "values" }, [
                    _vm._v(
                      _vm._s(
                        _vm.ColumnUtils.resolveColumnLabel(
                          _vm.TYPE_NAMES.basic_data_User,
                          "userId",
                          _vm.companyBpm.createdBy,
                          "chineseName"
                        )
                      )
                    )
                  ]),
                  _c("td", { staticClass: "header" }, [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_InitiateBranchCompany"))
                    )
                  ]),
                  _c("td", { staticClass: "values" }, [
                    _vm._v(
                      _vm._s(
                        _vm.ColumnUtils.resolveColumnLabel(
                          _vm.TYPE_NAMES.basic_data_Office,
                          "officeId",
                          !_vm.processInfo
                            ? _vm.$store.getters.currentOfficeId
                            : _vm.processInfo.officeId,
                          "chineseName"
                        )
                      )
                    )
                  ])
                ])
              ]
            ),
            _c(
              "div",
              { staticStyle: { "min-height": "250px" } },
              [
                _c("cargo-ag-grid", {
                  staticStyle: {
                    width: "100%",
                    height: "250px",
                    "flex-grow": "1"
                  },
                  attrs: {
                    "config-module": "251021",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.companyBpm.companyList
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            !_vm.isApply
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "20px",
                      "margin-bottom": "20px",
                      width: "100%",
                      height: "30px"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { float: "right" },
                        attrs: { type: "primary" },
                        on: { click: _vm.onViewCompanyRequest }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_ViewPartnerDetails"))
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isApply
              ? _c("div", { staticStyle: { border: "1px solid #E3E3E3" } }, [
                  _c(
                    "div",
                    { staticStyle: { margin: "5px" } },
                    [
                      _c(
                        "el-tabs",
                        {
                          model: {
                            value: _vm.activeName,
                            callback: function($$v) {
                              _vm.activeName = $$v
                            },
                            expression: "activeName"
                          }
                        },
                        [
                          _vm.isApprove
                            ? _c(
                                "el-tab-pane",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ApprovalComments"
                                    ),
                                    name: "comments"
                                  }
                                },
                                [
                                  _c("process-content", {
                                    attrs: { form: _vm.form }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_ApprovalCommentsRecord"
                                ),
                                name: "record"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "max-height": "130px",
                                    overflow: "auto"
                                  }
                                },
                                _vm._l(_vm.records, function(record, index) {
                                  return _c(
                                    "div",
                                    { key: index },
                                    [
                                      _c(
                                        "el-card",
                                        { staticClass: "box-card" },
                                        [
                                          record.actionType !==
                                          _vm.Action_Type_Submit.code
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex"
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "CargoMsg.Cargo_Approver"
                                                        )
                                                      ) + "： "
                                                    )
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ColumnUtils.resolveColumnLabel(
                                                          _vm.TYPE_NAMES
                                                            .basic_data_User,
                                                          "userId",
                                                          record.userId,
                                                          "chineseName"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "30px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_ApprovalComments"
                                                          )
                                                        ) + "： "
                                                      )
                                                    ]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.WorkflowUtil.getActionName(
                                                          record.actionType
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "30px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Remarks"
                                                          )
                                                        ) + "： "
                                                      )
                                                    ]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(record.remark)
                                                    )
                                                  ]),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "30px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_ApprovalTime"
                                                          )
                                                        ) + "： "
                                                      )
                                                    ]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(record.createTime)
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex"
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "CargoMsg.Cargo_Initiator"
                                                        )
                                                      ) + "： "
                                                    )
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ColumnUtils.resolveColumnLabel(
                                                          _vm.TYPE_NAMES
                                                            .basic_data_User,
                                                          "userId",
                                                          record.userId,
                                                          "chineseName"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "30px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Remarks"
                                                          )
                                                        ) + "： "
                                                      )
                                                    ]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(record.remark)
                                                    )
                                                  ]),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "30px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_StartTime"
                                                          )
                                                        ) + "： "
                                                      )
                                                    ]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(record.createTime)
                                                    )
                                                  ])
                                                ]
                                              ),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    record.files &&
                                                    record.files.length > 0,
                                                  expression:
                                                    "record.files && record.files.length > 0"
                                                }
                                              ],
                                              staticStyle: {
                                                "margin-top": "10px",
                                                cursor: "pointer"
                                              }
                                            },
                                            _vm._l(record.files, function(
                                              file,
                                              index
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass: "file-style",
                                                  staticStyle: {
                                                    display: "inline-block"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                        display: "flex"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.downloadFile(
                                                            file.fileId
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-paperclip"
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "file-name"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              file.fileName
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            color: "darkgray"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.WorkflowUtil.fileSizeLabel(
                                                                file.fileSize
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.isApply && _vm.hasBtn
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "10px",
                      "margin-bottom": "10px"
                    }
                  },
                  [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Remarks")) + ":")
                    ]),
                    _c("process-content", { attrs: { form: _vm.form } })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c("template", { staticStyle: { height: "65px" }, slot: "footer" }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _vm._v(
                " " + _vm._s(_vm.$t("CargoMsg.Cargo_RefuseAndReturnNode")) + " "
              )
            ]),
            _c(
              "div",
              { staticStyle: { float: "right", display: "flex" } },
              [
                _vm._l(_vm.btnList, function(btn, index) {
                  return _c(
                    "el-button",
                    {
                      key: index,
                      attrs: { title: btn.title, type: btn.color },
                      on: {
                        click: function($event) {
                          return _vm.onAction(btn)
                        }
                      }
                    },
                    [_vm._v(_vm._s(btn.actionName))]
                  )
                }),
                _c("el-button", { on: { click: _vm.handleClose } }, [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))
                ])
              ],
              2
            )
          ])
        ],
        2
      ),
      _vm.chooseUserDialogAdd.visible
        ? _c("choose-user-dialog-add", {
            attrs: {
              title: _vm.$t("CargoMsg.Cargo_SelectSigner"),
              visible: _vm.chooseUserDialogAdd.visible,
              value: _vm.chooseUserDialogAdd.userIds
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.chooseUserDialogAdd, "visible", $event)
              },
              close: function($event) {
                _vm.chooseUserDialogAdd.visible = false
              },
              change: _vm.addSignature
            }
          })
        : _vm._e(),
      _vm.chooseUserDialogTransfer.visible
        ? _c("choose-user-dialog-transfer", {
            attrs: {
              title: _vm.$t("CargoMsg.Cargo_SelectTransferor"),
              visible: _vm.chooseUserDialogTransfer.visible,
              value: _vm.chooseUserDialogTransfer.userIds
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.chooseUserDialogTransfer, "visible", $event)
              },
              close: function($event) {
                _vm.chooseUserDialogTransfer.visible = false
              },
              change: _vm.transferSignature
            }
          })
        : _vm._e(),
      _c("company-dialog", {
        attrs: {
          title: _vm.$t("CargoMsg.Cargo_ViewPartnerDetails"),
          visible: _vm.companyDialog.visible,
          "row-data": _vm.companyDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.companyDialog, "visible", $event)
          },
          close: function($event) {
            _vm.companyDialog.visible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }